<template>
  <div>

    <!--百度地图-->
    <label>关键词：<input v-model="keyword"></label>
    <baidu-map :style="{width: map.width, height: map.height}" class="map" :zoom="map.zoom"
               :center="{lng: map.center.lng, lat: map.center.lat}"
               @rightclick="addMarker" :scroll-wheel-zoom="true" :mapStyle="mapStyle">
      <!--搜索结果框-->
      <bm-local-search v-show="false" :keyword="keyword" :auto-viewport="true" @infohtmlset="searchResultClick">
      </bm-local-search>
      <!--定位点-->
      <bm-marker v-for="marker of markers" :key="marker.code" :position="{lng: marker.lng, lat: marker.lat}">
        <bm-label :content="marker.descript" :labelStyle="{color: 'red', fontSize: '8px'}" :offset="{width: 0, height: 30}"/>
        <!--信息窗体-->
        <bm-info-window :position="{lng: marker.lng, lat: marker.lat}" title="Info Window Title" :show="marker.show">
          <p>{{marker.code}}</p>
        </bm-info-window>
      </bm-marker>
      <!--折线-->
      <bm-polyline :path="markers" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="4" :editing="false" :clicking="false">
      </bm-polyline>
    </baidu-map>

    <!--定位组tab-->
    <el-tag type="info" effect="plain" size="medium" @click="addGroup">+ 增加</el-tag>
    <el-tag
      :key="item.id"
      v-for="item in tabData"
      closable
      size="medium"
      @click="tabChange(item)"
      @close="delGroup(item.id)"
      :effect="item.effect">
      {{item.name}} <i class="el-icon-edit" @click="editGroup(item.name, item.descript, item.province)"></i>
    </el-tag>

    <!--类型tab-->
    <el-tabs v-model="defaultTab" @tab-click="typeTabChange">
      <el-tab-pane label="简略" name="brief">
        <el-table
          :data="briefMarkers"
          style="width: 100%"
          row-key="id"
          border
          lazy
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="lat" label="纬度" width="100"></el-table-column>
          <el-table-column prop="lng" label="经度" width="100"></el-table-column>
          <el-table-column label="描述" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.descript" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column label="旅游日期" width="400">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期">
              </el-date-picker>
              <el-date-picker
                v-model="scope.row.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期">
              </el-date-picker>
            </template>
          </el-table-column>
          <!--第二步  开始进行修改和查询操作-->
          <el-table-column label="操作" align="center" min-width="100">
            <template slot-scope="scope">
              <el-button type="danger" @click="delMarker(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="详细" name="detail">
        <el-table
          :data="detailMarkers"
          style="width: 100%"
          row-key="id"
          border
          lazy
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="lat" label="纬度" width="100"></el-table-column>
          <el-table-column prop="lng" label="经度" width="100"></el-table-column>
          <el-table-column label="描述" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.descript" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column label="旅游日期" width="400">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期">
              </el-date-picker>
              <el-date-picker
                v-model="scope.row.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期">
              </el-date-picker>
            </template>
          </el-table-column>
          <!--第二步  开始进行修改和查询操作-->
          <el-table-column label="操作" align="center" min-width="100">
            <template slot-scope="scope">
              <el-button type="primary" :disabled="scope.$index == 0" @click="moveMarker(scope.$index, scope.$index - 1)">上移</el-button>
              <el-button type="primary" :disabled="scope.$index == detailMarkers.length - 1" @click="moveMarker(scope.$index, scope.$index + 1)">下移</el-button>
              <el-button type="danger" @click="delMarker(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!--组修改框-->
    <el-dialog title="请输入组名" :visible.sync="groupFormVisible">
      <el-form>
        <el-form-item label="组名" label-width="120px">
          <el-input v-model="groupName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="省份" label-width="120px">
          <el-input v-model="groupProvince" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="120px">
          <el-input v-model="groupDesc" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupFormVisible=false">取消</el-button>
        <el-button type="primary" @click="sendSaveGroup">确定</el-button>
      </div>
    </el-dialog>

    <el-button class="el-form-button" type="primary" v-on:click="saveLocation">保存</el-button>

  </div>
</template>

<script>
import {BMapStyle, HttpResp} from '../../constant/index';
import {tourApi} from '../../api/index';
//百度地图
import BaiduMap from 'vue-baidu-map'
import BmScale from 'vue-baidu-map/components/controls/Scale';
import BmNavigation from 'vue-baidu-map/components/controls/Navigation';
import BmMarkerClusterer from  'vue-baidu-map/components/extra/MarkerClusterer';
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow';

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥
  ak: 'uQQSc6GEFrtD9vEfpphUbbLlW9BLBUKW'
})
export default {
  name: 'TourGroupList',
  data() {
    return {
      components: {
        BaiduMap,
        BmScale,
        BmNavigation,
        BmMarkerClusterer,
        BmInfoWindow
      },
      defaultTab: "brief",
      keyword: "",
      mapStyle: BMapStyle.MAP_STYLE,
      tabData: [],
      tableData: [],
      markers: [],
      briefMarkers: [],
      detailMarkers: [],
      isAddGroup: false,
      groupName: "",
      groupProvince: "",
      groupDesc: "",
      groupFormVisible: false,
      map: {
        width: '100%',
        height: '300px',
        zoom: 4,
        center: {
          lng: 106.39,
          lat: 32.52,
        },
      },
      groupId: "",
      groupType: 1,
    }
  },
  mounted: function () {
    this.setDefaultMap();
    this.loadData();
  },
  methods: {
    loadData() {
      tourApi.listGroup().then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.tabData = data.data;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 还原地图设置
    setDefaultMap() {
      this.map.zoom = 4;
      this.map.center.lat = 32.52;
      this.map.center.lng = 106.39;
    },
    // tab切换
    typeTabChange(tab) {
      let groupType = tab.name;
      if (groupType == "brief") {
        this.groupType = 1;
      } else {
        this.groupType = 2;
      }
      this.typeChange();
    },
    // 还原组tag选中状态
    clearTagStyle() {
      for (let i = 0; i < this.tabData.length; i++) {
        this.tabData[i].effect = 'light';
      }
    },
    // tab切换
    tabChange(tab) {
      this.clearTagStyle();
      tab.effect = 'dark';
      // 点击创建tab时不调接口
      if (tab.id != this.groupId) {
        this.groupId = tab.id;
        this.loadLocation();
      }
    },
    // 组类型切换
    typeChange() {
      if (this.groupType == 1) {
        this.markers = this.briefMarkers;
      } else {
        this.markers = this.detailMarkers;
      }
    },
    // 查询定位
    loadLocation() {
      tourApi.listLocation(this.groupId).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.briefMarkers = data.data.brief;
          this.detailMarkers = data.data.detail;
          this.typeChange();

          // 如果有定位点，修改地图显示区域
          if (this.briefMarkers.length > 0) {
            this.map.zoom = 7;
            this.map.center.lat = this.briefMarkers[0].lat;
            this.map.center.lng = this.briefMarkers[0].lng;
          } else {
            this.setDefaultMap();
          }
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 增加定位点
    addMarker(target) {
      this.markers.push({
        descript: "",
        lng: target.point.lng,
        lat: target.point.lat,
      })
    },
    // 删除定位点
    delMarker(index) {
      this.markers.splice(index, 1);
    },
    // 移动定位点
    moveMarker(index1, index2) {
      let temp = this.markers[index1];
      this.markers.splice(index1, 1, this.markers[index2]);
      this.markers.splice(index2, 1, temp);
    },
    // 保存定位
    saveLocation() {
      let data = {
        "brief": this.briefMarkers,
        "detail": this.detailMarkers,
      }
      tourApi.saveLocation(this.groupId, data).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.$message({
            type: 'success',
            message: "保存成功"
          });
          this.loadLocation();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 修改组
    editGroup(groupName, groupDesc, groupProvince) {
      this.groupFormVisible = true;
      this.groupName = groupName;
      this.groupDesc = groupDesc;
      this.groupProvince = groupProvince;
      this.isAddGroup = false;
    },
    // 增加组
    addGroup() {
      this.groupFormVisible = true;
      this.groupName = "";
      this.groupDesc = "";
      this.groupProvince = "";
      this.isAddGroup = true;
    },
    // 保存组网络请求
    sendSaveGroup() {
      let data = {
        id: this.isAddGroup ? null : this.groupId,
        name: this.groupName,
        province: this.groupProvince,
        descript: this.groupDesc,
      }
      tourApi.saveGroup(data).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.$message({
            type: 'success',
            message: "保存成功"
          });
          this.groupFormVisible = false;
          this.loadData();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    delGroup(groupId) {
      this.$confirm('是否继续删除组 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sendDelGroup(groupId);
      })
    },
    // 删除组网络请求
    sendDelGroup(groupId) {
      tourApi.delGroup(groupId).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.$message({
            type: 'success',
            message: "删除成功"
          });
          this.loadData();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 搜索结果点击添加到列表
    searchResultClick(target){
      this.markers.push({
        descript: target.title,
        lng: target.point.lng,
        lat: target.point.lat,
      })
    },

  }

}
</script>
<style>
  .el-tag {
    margin: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tour/TourGroupList.vue